export enum priceListUrls {
    priceList = "price-list"
}